import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';
import { UpcomingRounds } from '../UpcomingRounds';
import Terms from '../Terms';
import { CountdownTimer } from '../CountdownTimer';
import { EnterPrompt } from '../EnterPrompt';
import LoginPrompt from '../LoginPrompt';
import PreRaceInfo from '../PreRaceInfo';

const OpenState = ({
    title,
    eventName,
    prize,
    TermsLink,
    loggedIn,
    sweepId,
    openLogin,
    startDate,
    canEnterSweepstake,
    displayCountdownTimer
}) => {
    return (
        <>
            {displayCountdownTimer && (
                <Styled.CountDownTimerWrapper>
                    {startDate && (
                        <CountdownTimer
                            name={eventName}
                            date={new Date(startDate).getTime()}
                        />
                    )}
                </Styled.CountDownTimerWrapper>
            )}
            <Styled.ContentWrapper>
                <PreRaceInfo
                    title={title}
                    raceName={eventName}
                    raceDate={startDate}
                    prize={prize}
                >
                    {canEnterSweepstake && (
                        <>
                            <Styled.ButtonWrapper>
                                {loggedIn ? (
                                    <EnterPrompt sweepId={sweepId} />
                                ) : (
                                    <LoginPrompt
                                        openLogin={openLogin}
                                        hasEventStarted={false}
                                    />
                                )}
                            </Styled.ButtonWrapper>
                            <Terms
                                startDate={startDate}
                                TermsLink={TermsLink}
                            />
                        </>
                    )}
                </PreRaceInfo>
                <Styled.UpComingRoundsWrapper>
                    <UpcomingRounds />
                </Styled.UpComingRoundsWrapper>
            </Styled.ContentWrapper>
        </>
    );
};

OpenState.propTypes = {
    title: PropTypes.string.isRequired,
    eventName: PropTypes.string.isRequired,
    prize: PropTypes.string.isRequired,
    TermsLink: PropTypes.func.isRequired,
    loggedIn: PropTypes.bool.isRequired,
    sweepId: PropTypes.string.isRequired,
    openLogin: PropTypes.func.isRequired,
    startDate: PropTypes.string.isRequired,
    canEnterSweepstake: PropTypes.bool.isRequired,
    displayCountdownTimer: PropTypes.bool.isRequired
};

export default OpenState;
